import React from 'react';
import {observer} from 'mobx-react';
import Dialog from "@mui/material/Dialog";
import {useOutletContext} from "react-router-dom";
import {LiFiWidget, WidgetConfig} from '@lifi/widget';
import {contractAddresses} from "../../../helpers/config/contracts.config";
import leverageUiColors from "../../../helpers/config/colors";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {polygon, arbitrum, mainnet, optimism, base, bsc, avalanche, zkSync, polygonZkEvm} from 'wagmi/chains'

const widgetConfig: WidgetConfig = {
    integrator: 'NereusFinance',
    fromChain: 1,
    fromToken: contractAddresses.ethereum.usdt,
    toChain: 137,
    toToken: contractAddresses.polygon.usdt,
    chains: {
        allow: [polygon.id, mainnet.id, arbitrum.id, optimism.id, base.id, bsc.id, avalanche.id, zkSync.id, polygonZkEvm.id],//only chains configured in warmi config can be used here
    },
    theme: {
        palette: {
            primary: { main: leverageUiColors.main },
            secondary: { main: leverageUiColors.mainLight },
            background: {
                paper: leverageUiColors.neutralNight, // bg color for cards
                default: leverageUiColors.bg2, // bg color container
            },
            grey: {
                300: leverageUiColors.neutralDarkBlue, // border light theme
                800: leverageUiColors.neutralDarkBlue, // border dark theme
            },
        },
        shape: {
            borderRadius: 4,
            borderRadiusSecondary: 4,
        },
    },
    appearance: 'dark',
    hiddenUI: ['appearance', 'walletMenu', 'toAddress', 'language'],
};

const BridgeDialog: React.FC = observer(() => {
    const {onClose} = useOutletContext<{ onClose: () => {} }>()

    return (
        <Dialog open={true}>
            <div className="ModalWrapper__header flex justify-between items-center pt-4 pr-4 pl-4">
                <h2 className="nereus-body-m">Bridge</h2>
                <IconButton className="ModalWrapper__close" onClick={onClose}>
                    <CloseIcon style={{color: 'white'}}/>
                </IconButton>
            </div>
            <LiFiWidget integrator={widgetConfig.integrator} config={widgetConfig}/>
        </Dialog>
    );
});

export default BridgeDialog;
